import { IN_OPERATOR } from './reportsConsts';

export const buildFilter = (dimension, values, operator = IN_OPERATOR, options = {}) => ({
    dimension,
    operator,
    values,
    ...(Object.keys(options).length && { options }),
});

export const buildMetricParams = metrics => {
    const { regular, cohortMetrics, cohortPeriods } = metrics.reduce(
        (acc, { apiName, apiType, period }) => {
            if (apiType === 'cohort') {
                acc.cohortMetrics.add(apiName);
                acc.cohortPeriods.add(period);
            } else {
                acc.regular.add(apiName);
            }
            return acc;
        },
        { regular: new Set(), cohortMetrics: new Set(), cohortPeriods: new Set() }
    );

    return {
        metrics: [...regular],
        cohort_metrics: [...cohortMetrics],
        cohort_periods: [...cohortPeriods],
    };
};
